import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { Button } from "./ui/Button";

const CancelConfirmModal = ({ show, onHide, onConfirm, message, isLoading = false, isDark }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  if (!show) return null;

  const modalContent = (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center"
      style={{ zIndex: 99999 }}
      onClick={onHide}
    >
      <div
        className={`rounded-[12px] p-[32px] max-w-[420px] w-full mx-4 shadow-lg flex flex-col items-center gap-[24px] transition-colors duration-200 ${
          isDark ? 'bg-[#161515]' : 'bg-white'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <p className={`text-[16px] font-semibold text-center m-0 break-all transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>
          {message}
        </p>

        <div className="flex gap-[16px] w-full">
          <Button
            variant="ghost"
            className={`flex-1 text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${
              isDark
                ? 'bg-[#cd6d2c] text-[#000000] hover:bg-[#e37f3d]'
                : 'bg-[#cd6d2c] text-white hover:bg-[#b35d24]'
            }`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center gap-[8px]">
                <div className={`w-4 h-4 border-2 border-t-transparent rounded-full animate-spin ${
                  isDark ? 'border-[#000000]' : 'border-white'
                }`} />
                Cancelling...
              </div>
            ) : (
              'Confirm'
            )}
          </Button>
          <Button
            variant="ghost"
            className={`flex-1 text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${
              isDark
                ? 'bg-[#000000] text-[#ffffff] hover:bg-[#1a1a1a]'
                : 'bg-[#D9D9D9] text-[#072837] hover:bg-[#D9D9D9]'
            }`}
            onClick={onHide}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default CancelConfirmModal;
